import { FURNITURE_CONFIG } from '~/components/ThreeDModel/furnitureConfig'

export interface TopPanelDimensionsInput {
  width: number
  depth: number
  isNewCollection: boolean
}

export interface TopPanelDimensions {
  thickness: number
  width: number
  height: number
}

export function computeTopPanelDimensions(
  input: TopPanelDimensionsInput
): TopPanelDimensions {
  const { panelThickness } = FURNITURE_CONFIG
  const { width, depth, isNewCollection } = input

  const topWidth = isNewCollection ? width - panelThickness * 2 : width
  const topHeight = depth - panelThickness

  return {
    thickness: panelThickness,
    width: topWidth,
    height: topHeight,
  }
}
